<template>
  <div class="columns is-multiline">
    <div class="column is-half">
      <!-- 저장 -->
      <div class="btn-group-justify-end" v-if="!$route.query.id">
        <button class="button is-primary" @click="done">전송하기</button>
      </div>
      <div class="box">
        <admin-box-item title="푸시 알림 전송" subtitle="아이폰, 안드로이드 앱에 푸시알림을 전송할 수 있습니다">
          <div class="columns is-multiline" v-if="!$route.query.id">
            <div class="column is-full">
              <admin-form-item label="전송 기기">
                <lp-radio :val="push.device"
                          value_name="value"
                          label_name="label"
                          :data="deviceOptions"
                          @onSelect="onSelectDevice"></lp-radio>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="전송 대상">
                <lp-radio :val.sync="push.target"
                          value_name="value"
                          label_name="label"
                          :data="[{label:'일반회원',value:0}, {label:'마케팅정보수신동의회원', value:2}]"></lp-radio>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="제목*">
                <input class="input"
                       :value="push.title"
                       @input="e => push.title = e.target.value"
                       placeholder="제목을 입력하세요."
                       type="text">
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="내용*">
                  <textarea style="height:90px"
                            class="input"
                            :value="push.msg"
                            placeholder="내용을 입력하세요."
                            @input="e=> push.msg = e.target.value"></textarea>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="URL 주소*" desc="URL에 https 또는 http를 붙여주세요." tip="푸시 알림 클릭시 이동할 URL 주소를 입력하는 곳으로, 필수 입력란 입니다. ">
                <input class="input"
                       :value="push.link"
                       @input="e => push.link = e.target.value"
                       placeholder="푸시 알림 클릭시 이동할 URL 주소를 입력하세요."
                       type="text">
              </admin-form-item>
            </div>
            <div class="column is-full flex">
              <!--<admin-form-item label="썸네일">
                <input-img :url.sync="push.thumbnail" :idx="1"></input-img>
              </admin-form-item>-->
              <admin-form-item label="이미지" tip="푸시 알림에서 보일 이미지를 등록할 수 있습니다. ">
                <input-img :url.sync="push.img" :idx="2"></input-img>
              </admin-form-item>
            </div>
          </div>
          <div v-else>
            <admin-form-item label="전송 기기">{{ push.device===''?'전체':push.device }}</admin-form-item>
            <admin-form-item label="전송 대상">
              {{ push.target===0?'전체회원':push.target===1?'일반회원':'마케팅수신동의회원' }}
            </admin-form-item>
            <admin-form-item label="제목*">{{ push.title }}</admin-form-item>
            <admin-form-item label="내용*">{{ push.msg }}</admin-form-item>
            <admin-form-item label="URL 주소*" desc="URL에 https 또는 http를 붙여주세요.">
              {{ push.link }}
            </admin-form-item>
            <admin-form-item label="이미지">
              <div :style="thumbImgField(push.img)"></div>
            </admin-form-item>
          </div>
        </admin-box-item>
      </div>

      <!-- 저장 -->
      <div class="btn-group-justify-end" v-if="!$route.query.id">
        <button class="button is-primary" @click="done">전송하기</button>
      </div>
    </div>

    <modal name="sendModal" :adaptive="true" :width="400" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div style="text-align: center;padding:36px">푸시 알림을 전송하시겠습니까?</div>
        <div class="flex-center">
          <button class="button is-primary" @click="saveData">예(Y)</button>
          <button class="button"
                  style="background-color:#A0A0A0;color:white;margin-left:12px"
                  @click="$modal.hide('sendModal')">아니요(N)</button>
        </div>
      </div>
    </modal>

    <modal name="sendConfirmModal" :adaptive="true" :width="400" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div style="text-align: center;padding:36px">푸시 알림이 전송되었습니다.</div>
        <div class="flex-center">
          <button class="button is-primary" @click="hideConfirmModal">확인</button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
  import AdminBoxItem from "../../module/admin/AdminBoxItem";
  import AdminFormItem from "../../module/admin/AdminFormItem";
  import LpRadio from "../../module/common/LpRadio";
  import InputImg from "../../module/common/InputImg";


  export default {
    name: 'PushReg',
    layout: "Main",
    components: {
      InputImg,
      LpRadio,
      AdminFormItem,
      AdminBoxItem
    },
    data() {
      return {
        deviceOptions: [
          {
            label: '전체',
            value: 'all'
          },
          {
            label: 'Android',
            value: 'android'
          },
          {
            label: 'IOS',
            value: 'ios'
          },
        ],
        push: {
          device: 'all',
          title: '',
          msg: '',
          link: '',
          thumbnail: '',
          img: '',
          target: 0
        }
      };
    },
    created() {
      this.getData();
    },
    methods: {
      // 게시판 노출 여부
      onSelectDevice(val) {
        this.push.device = val;
      },

      done() {
        let err = '';
        if ( !this.push.title ) err = '제목을 입력하세요.';
        else if( !this.push.msg ) err= '내용을 입력하세요.';
        else if( !this.push.link ) err= 'URL 주소를 입력하세요.';
        else if( this.push.link.indexOf('http')===-1 ) {
          err = 'URL에 https 또는 http를 붙여주세요.';
        }

        if ( err ) {
          this.toast(err);
          return;
        }

        this.$modal.show('sendModal');
      },
      getData() {
        this.$axios.get(`admin/push/${this.$route.query.id}`).then(res=> {
          this.push = res.data;
        })
      },
      saveData() {
        let push = this.cloneItem(this.push);
        if (push.device === 'all') {
          push.device = '';
        }

        this.$axios.post('admin/push', push).then(res=>{
          if(res.status===200){
            this.$modal.hide('sendModal');
            this.$modal.show('sendConfirmModal');
            //this.$router.replace(this.getPath('push'));
          }
        }).catch(error => {
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      },
      hideConfirmModal() {
        this.$modal.hide('sendConfirmModal');
        this.$router.replace(this.getPath('push'));
      },
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  @import '~assets/css/lp_main';

</style>
